// Debugging function
function debug(message) {
  // Commented out to reduce console clutter
  // console.log("Debug: " + message);
}

// Function to set a cookie
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
  debug("Cookie set: " + name + "=" + value);
}

// Function to get a cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Function to handle the redirect
function handleRedirect() {
  var chosenPage = getCookie('chosen_page');
  var currentPath = window.location.pathname;

  // Skip redirect if we're not on the homepage or if already redirected
  if ((currentPath !== '/' && currentPath !== '/pages/homepage') || !chosenPage) {
    debug("No need to redirect.");
    return;
  }

  // Perform redirection if on homepage and cookie is set
  var redirectUrl = '/pages/' + chosenPage;
  debug("On homepage, redirecting to: " + redirectUrl);
  window.location.replace(redirectUrl);
}

// Function to handle setting cookies based on page paths
function handlePageSpecificCookies() {
  var currentPath = window.location.pathname;
  if (currentPath === '/pages/mens') {
    setCookie('chosen_page', 'mens', 30);
  } else if (currentPath === '/pages/womens') {
    setCookie('chosen_page', 'womens', 30);
  }
}

// Run page-specific cookie setting
handlePageSpecificCookies();

// Function to set up click handlers
function setupClickHandlers() {
  var links = document.getElementsByTagName('a');
  debug("Found " + links.length + " links");

  for (var i = 0; i < links.length; i++) {
    var link = links[i];
    var href = link.getAttribute('href');

    if (href === '/pages/mens') {
      debug("Setting up men's link: " + href);
      link.addEventListener('click', function () {
        setCookie('chosen_page', 'mens', 30);
      });
    } else if (href === '/pages/womens') {
      debug("Setting up women's link: " + href);
      link.addEventListener('click', function () {
        setCookie('chosen_page', 'womens', 30);
      });
    }
  }
}

// Set up click handlers after DOM is loaded
document.addEventListener('DOMContentLoaded', function () {
  debug("DOMContentLoaded event fired");
  setupClickHandlers();
});

debug("Script loaded");
